import React, { useState } from 'react';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { TextInput } from '@fabric-ui/components';
import AvDialog from '../../components/AvDialog';
import Select from '../../components/Select';
import { useAvContext } from '../../context/AvContextProvider';
import { useAllApps } from '../../hooks/useAllApps';
import { APP_PATHS } from '../../types';
import { CustomDashboardDto } from '../CustomDashboards/types';
import { renderOption } from './reports.utils';

interface Props {
  isSaveAsNewDialogOpen: boolean;
  setIsSaveAsNewDialogOpen: any;
  save: any;
  customDashboard: CustomDashboardDto;
}
const SaveAsNewDialog: React.FC<Props> = ({ isSaveAsNewDialogOpen, setIsSaveAsNewDialogOpen, customDashboard, save }) => {
  const { enabledApps } = useAvContext();
  const { data: AllApps = [] } = useAllApps();

  const [name, setName] = useState(customDashboard.name);
  const [apps, setApps] = useState<string[]>([]);

  const filteredAppsOption = enabledApps.map(({ id, name, iconFull }) => ({
    value: AllApps.find(({ name }) => id === APP_PATHS[name])?.name,
    title: name,
    iconFull,
  }));

  return (
    <div>
      <AvDialog
        open={isSaveAsNewDialogOpen}
        onClose={() => setIsSaveAsNewDialogOpen(false)}
        title="Save As New Report"
        footer={
          <Box sx={{ ...flex.justifyEndCenter, gap: 2 }}>
            <Button onClick={() => setIsSaveAsNewDialogOpen(false)}>Cancel</Button>
            <Button
              variant="outlined"
              onClick={() =>
                save({ isRerun: true, isCreate: true, customDashboard: { ...customDashboard, name, apps }, isSaveAsNew: true })
              }
              disabled={!name}>
              Save & Run
            </Button>
            <Button
              variant="contained"
              onClick={() => save({ isCreate: true, customDashboard: { ...customDashboard, name, apps }, isSaveAsNew: true })}
              disabled={!name}>
              Save
            </Button>
          </Box>
        }>
        <Box sx={{ ...flex.col, gap: 2 }}>
          <TextInput sx={{ width: '100%', maxWidth: 'unset' }} size="small" isRequired onChange={setName} value={name} label="Name" />
          <Select
            muiProps={{ disableClearable: true }}
            label="Pin to Apps"
            isMultiple
            size="small"
            value={apps}
            onChange={setApps}
            options={filteredAppsOption as any}
            renderOption={({ title, iconFull }: any) => renderOption({ title, iconFull })}
            style={{ '&.autocomplete-multiple': { '&, & .MuiFormControl-root': { maxWidth: '100%' } } }}
          />
        </Box>
      </AvDialog>
    </div>
  );
};

export default SaveAsNewDialog;
